import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=b1617176&lang=scss&scoped=true"

import exportComponent from "/home/lw8dl1214/actions-runner/_work/AIPR-Frontend/AIPR-Frontend/haleon-ar-detector/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b1617176"]])

export default __exports__